<div class="dashboarditem-container {{cssClass}}">
  <!-- <div class="dashboarditem-title">{{title}}</div> -->
  <div class="dashboarditem-content">
    <ng-content></ng-content>
  </div>
</div>
